import React, {useEffect, useRef} from "react";

import styles from "./Gafam.module.scss";
import Image from "./Global/Image";

import src from "../images/background-01.jpg";
import srcRet from "../images/background-01@2x.jpg";
import webp from "../images/background-01.webp";
import webpRet from "../images/background-01@2x.webp";

import sword from "../images/illustrations/sword.svg";
import vr from "../images/illustrations/vr.svg";
import hearts from "../images/illustrations/hearts.svg";
import mobile from "../images/illustrations/mobile.svg";

import ArticleLink from "./Elements/ArticleLink";
import Plus from "./Pictos/Plus";


export default function Gafam() {
    const parent = useRef(null)
    const tendances = useRef(null);


    return (
        <section className={styles.Main} ref={parent}>
            <div className="container">
                <ArticleLink image={{src, srcRet, webp, webpRet}} title={'Les Gafam à la conquête du jeu vidéo'} url={'https://www.boursier.com/dossiers/les-jeux-video-avec-etoro/economie/les-gafam-a-la-conquete-du-jeu-video-47343.html'}/>

                <div className={styles.Tendances} ref={tendances}>
                    <p className={"head-text"}>
                        Des tendances qui <br/>
                        <strong>stimulent davantage le marché…</strong>
                    </p>

                    <div className={styles.TendancesWrapper}>
                        <article className={'active'}>
                            <Image src={sword}>
                                <p>
                                    Le monde du cinéma et celui des jeux ne vont-ils plus faire qu’un ?
                                </p>
                            </Image>

                            <div className={styles.TendanceText}>
                                <p>
                                    Avec l’explosion des plateformes de streaming, de nombreux projets d’adaptations de
                                    films voient le jour et sont actuellement en projet. En effet, après avoir emprunté
                                    au cinéma de nombreuses références, c’est au tour du cinéma lui-même de lorgner du
                                    côté des grands noms du jeu vidéo. Les projets de série et films en cours
                                    d’adaptation sur les différentes plateformes :
                                </p>

                                <ul className={'accordion'}>
                                    <li>
                                        <details>
                                            <summary>
                                                <p>
                                                    <strong>Netflix</strong>

                                                    <Plus/>
                                                </p>
                                            </summary>
                                            <p>
                                                « The Witcher – Saison 2 » et le spin off « The Witcher: Blood Origin » (CD Projekt Red) ; « Cyberpunk Edgerunners » (CD Projekt Red) ; «
                                                Splinter Cell » (Ubisoft) ; la série en live action « Pokemon » (Game Freak), «
                                                Sonic » (Sega) ; « Captain Laserhawk: A Blood Dragon Remix » (Ubisoft), « The
                                                Division » (Ubisoft), « Beyond Good & Evil » (Ubisoft), « Tomb Raider » (Crystal
                                                Dynamics), plusieurs séries de l’univers « Assassin’s Creed » (Ubisoft)
                                            </p>
                                        </details>
                                    </li>
                                    <li>
                                        <details>
                                            <summary>
                                                <p>
                                                    <strong>Amazon Prime Video</strong>
                                                    <Plus/>
                                                </p>
                                            </summary>

                                            <p>
                                                « Fallout » (Bethesda)
                                            </p>
                                        </details>
                                    </li>
                                    <li>
                                        <details>
                                            <summary>
                                                <p>
                                                    <strong>Apple TV</strong>
                                                    <Plus/>
                                                </p>
                                            </summary>

                                            <p>
                                                « Crash Bandicoot » (Beenox / Activision) ; « Spyro » (Toys For Bob / Activision)
                                            </p>
                                        </details>
                                    </li>
                                    <li>
                                        <details>
                                            <summary>
                                                <p>
                                                    <strong>HBO Max</strong>
                                                    <Plus/>
                                                </p>
                                            </summary>

                                            <p>
                                                « The Last of Us » (Naughty Dog)
                                            </p>
                                        </details>
                                    </li>
                                    <li>
                                        <details>
                                            <summary>
                                                <p>
                                                    <strong>Paramount +</strong>
                                                    <Plus/>
                                                </p>
                                            </summary>

                                            <p>
                                                « Halo » (343 Industries)
                                            </p>
                                        </details>
                                    </li>
                                </ul>
                            </div>
                        </article>

                        <article>
                            <Image src={vr}>
                                <p>
                                    Un développement tous azimuts des technologies.
                                </p>
                            </Image>

                            <div className={styles.TendanceText}>
                                <p>
                                    • <strong>La réalité virtuelle</strong> : grâce à la réalité virtuelle, les
                                    créateurs de jeux vidéo ont trouvé un moyen unique de plonger les joueurs au cœur
                                    d’une histoire et pour leur faire vivre une véritable immersion. Alors que cette
                                    forme innovante de jeu se généralise progressivement, et à mesure que l’équipement
                                    nécessaire pour profiter pleinement d’une expérience en RV deviendra plus abordable,
                                    elle deviendra beaucoup plus accessible au grand public. Parmi les casques de
                                    réalité virtuels commercialisés, on retrouve notamment l’Oculus Rift, le HTC Vive
                                    sur PC, et le PlayStation VR pour la console de Sony.
                                </p>

                                <p>
                                    • <strong>La réalité augmentée</strong> : La réalité augmentée est une technologie
                                    de niche qui pourrait avoir un impact majeur sur l’industrie vidéoludique dans les
                                    années à venir. Depuis quelques temps, les jeux de réalité, qui prennent en charge
                                    l’environnement réel existant du joueur et créent un terrain de jeu en superposant
                                    la réalité et des éléments de synthèse, se sont invités au sein de nombreux foyers.
                                    Le jeu « Pokémon Go » sur mobile a déjà attiré l’attention du monde entier…
                                </p>
                            </div>
                        </article>

                        <article>
                            <Image src={hearts}>
                                <p>
                                    Le « free to play », la gratuité peut rapporter gros.
                                </p>
                            </Image>

                            <div className={styles.TendanceText}>
                                <p>Les jeux gratuits qui, en principe, peuvent être joués totalement sans
                                    frais, ont facilité l’entrée en masse des joueurs. Ces jeux gratuits proposent
                                    toutefois de nombreux services avancés et autres options payantes. Des titres comme
                                    Candy Crush, Clash of Clans ou Angry Birds sont quelques-uns des jeux de
                                    téléchargement gratuit les plus populaires sur le marché des téléphones mobiles et
                                    des tablettes.
                                </p>
                            </div>
                        </article>

                        <article>
                            <Image src={mobile}>
                                <p>
                                    Explosion des
                                    jeux mobile.
                                </p>
                            </Image>

                            <div className={styles.TendanceText}>
                                <p>
                                    S’ils ont été longtemps associés à des joueurs du dimanche, les jeux mobile
                                    connaissent désormais un succès sans précédent, profitant d'un nombre croissant de
                                    joueuses et de la popularité des smartphones. Avec les confinements mis en place
                                    dans un contexte d’épidémie de Covid-19, les téléchargements de jeux mobile ont
                                    atteint des records l’an dernier. Selon le cabinet d’étude Newzoo, ce marché n’est
                                    pas près de décélérer, le segment du mobile pèsera plus de 90 milliards de dollars
                                    en 2021, soit plus de la moitié de la totalité du marché du jeu vidéo. En juin
                                    dernier, le propriétaire de l'emblématique licence GTA, Take-Two a racheté le studio
                                    mobile Nordeus pour 225 millions et a annoncé qu'il allait lancer 10 titres mobiles
                                    d'ici à mars 2022.
                                </p>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    )
}
